export default function Header() {
  return (
    <div className="topbar">
      <h1 className="page-title">Dashboard Overview</h1>
      <div className="user-info">
        {/* <div>
          <div style={{ fontWeight: "600" }}>Ahmad Khan</div>
          <div style={{ fontSize: "0.85rem", color: "#64748b" }}>admin@company.pk</div>
        </div>
        <div className="avatar">AK</div> */}
      </div>
    </div>
  );
}